var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"pa-0 ma-0",staticStyle:{"height":"170px","overflow-y":"auto"},attrs:{"dense":""}},[_vm._l((_vm.sortedProviders),function(item,i){return [_c('color-provider-list-item',{key:`provider_list_item_${item.id}_${i}`,attrs:{"provider":item,"groupId":_vm.groupId,"userIndexEdits":_vm.userIndexEdits},on:{"close":_vm.close}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }